import axios from "@/axios";

export default {
    list(payload) {
        return axios.get('masters', payload);
    },
    item(id) {
        return axios.get(`masters/${id}`);
    },
    update(payload) {
        return axios.post(`cabinet/master`, payload);
    },
    password(payload) {
        return axios.post(`cabinet/master/password`, payload);
    },
    specialization: {
        list() {
            return axios.get(`cabinet/master/specializations`);
        },
    },
    coworking: {
        list() {
            return axios.get(`cabinet/master/coworkings`);
        },
    },
    bonus: {
        list(page) {
            return axios.get(`cabinet/master/bonuses?page=${page}`);
        },
        referrals(page, search = '') {
            return axios.get(`cabinet/master/referrals?page=${page}&search=${search}`);
        },
    },
    notification: {
        list(page) {
            return axios.get(`cabinet/master/notifications?page=${page}`);
        },
    },
    price: {
        list(id) {
            return axios.get(`masters/${id}/prices`);
        },
        cabinetList() {
            return axios.get(`cabinet/master/prices`);
        },
        create(payload) {
            return axios.post(`cabinet/master/prices`, payload);
        },
        destroy(id) {
            return axios.destroy(`cabinet/master/prices/${id}`);
        }
    },
    portfolio: {
        list(id) {
            return axios.get(`masters/${id}/portfolio`);
        },
        cabinetList() {
            return axios.get(`cabinet/master/portfolio`);
        },
        create(payload) {
            return axios.post(`cabinet/master/portfolio`, payload);
        },
        destroy(id) {
            return axios.destroy(`cabinet/master/portfolio/${id}`);
        },
    },
    review: {
        list(id, page) {
            return axios.get(`masters/${id}/reviews?page=${page}`);
        },
        create(id, payload) {
            return axios.post(`masters/${id}/reviews`, payload);
        },
        destroy(master, review) {
            return axios.destroy(`masters/${master}/reviews/${review}`);
        },
    },
    package: {
        active(payload) {
            return axios.get(`cabinet/master/tariffs?active=1`, payload);
        },
        closed() {
            return axios.get(`cabinet/master/tariffs?closed=1`);
        },
    },
    client: {
        item(id, payload) {
            return axios.get(`cabinet/master/clients/${id}`, payload);
        },
        list(payload) {
            return axios.get(`cabinet/master/clients`, payload);
        },
        add(id, payload) {
            return axios.post(`cabinet/master/clients/${id}`, payload);
        },
        create(payload) {
            return axios.post(`cabinet/master/clients`, payload);
        },
        update(id, payload) {
            return axios.put(`cabinet/master/clients/${id}`, payload);
        },
    },
    rent: {
        list(payload) {
            return axios.get(`masters/rents`, payload);
        },
        create(payload) {
            let rents = {rents: {}};
            payload.forEach((val, index) => rents.rents[index] = val);
            return axios.post('masters/rents', rents);
        },
        destroy(id) {
            return axios.destroy(`masters/rents/${id}`);
        }
    },
    analytic: {
        general: {
            info(payload) {
                return axios.get('cabinet/master/analytics/general', payload);
            },
        },
        specialization: {
            list(payload) {
                return axios.get('cabinet/master/analytics/specializations', payload);
            },
        },
        history: {
            list(payload) {
                return axios.get('cabinet/master/analytics/history', payload);
            },
        },
        client: {
            list(payload) {
                return axios.get('cabinet/master/analytics/clients', payload);
            },
        },
    },
    record: {
        list(payload) {
            return axios.get('cabinet/master/records', payload);
        },
        create(payload) {
            return axios.post('cabinet/master/records', payload);
        },
        update(id, payload) {
            return axios.put(`cabinet/master/records/${id}`, payload);
        },
        destroy(id) {
            return axios.destroy(`cabinet/master/records/${id}`);
        },
        comment(id, payload) {
            return axios.post(`cabinet/master/records/${id}/comment`, payload);
        },
    },
    setting: {
        activity: {
            update(payload) {
                return axios.post(`cabinet/master/setting/activity`, payload);
            }
        }
    }
}
